import { IRowsData } from '../../../pages/Migrate/DiscoverTab/EditableTable';
import {
  IGetSourceDataPayload,
  IMigrateVMPayload,
  ISourceDataPayload,
  ITargetDataPayload,
} from '../../models/ConfigureArchitectureModels';
import { IStoreAction } from '../StoreHelper';

export enum ConfigureArchitectureActionTypes {
  SEND_SOURCE_DATA_START = 'SEND_SOURCE_DATA_START',
  SEND_SOURCE_DATA_SUCCESS = 'SEND_SOURCE_DATA_SUCCESS',
  SEND_SOURCE_DATA_ERROR = 'SEND_SOURCE_DATA_ERROR',

  GET_SOURCE_DATA_START = 'GET_SOURCE_DATA_START',
  GET_SOURCE_DATA_SUCCESS = 'GET_SOURCE_DATA_SUCCESS',
  GET_SOURCE_DATA_ERROR = 'GET_SOURCE_DATA_ERROR',

  UPDATE_SOURCE_DATA_START = 'UPDATE_SOURCE_DATA_START',
  UPDATE_SOURCE_DATA_SUCCESS = 'UPDATE_SOURCE_DATA_SUCCESS',
  UPDATE_SOURCE_DATA_ERROR = 'UPDATE_SOURCE_DATA_ERROR',

  SEND_TARGET_DATA_START = 'SEND_TARGET_DATA_START',
  SEND_TARGET_DATA_SUCCESS = 'SEND_TARGET_DATA_SUCCESS',
  SEND_TARGET_DATA_ERROR = 'SEND_TARGET_DATA_ERROR',

  GET_TARGET_DATA_START = 'GET_TARGET_DATA_START',
  GET_TARGET_DATA_SUCCESS = 'GET_TARGET_DATA_SUCCESS',
  GET_TARGET_DATA_ERROR = 'GET_TARGET_DATA_ERROR',

  UPDATE_TARGET_DATA_START = 'UPDATE_TARGET_DATA_START',
  UPDATE_TARGET_DATA_SUCCESS = 'UPDATE_TARGET_DATA_SUCCESS',
  UPDATE_TARGET_DATA_ERROR = 'UPDATE_TARGET_DATA_ERROR',

  GET_SUMMARY_DATA_START = 'GET_SUMMARY_DATA_START',
  GET_SUMMARY_DATA_SUCCESS = 'GET_SUMMARY_DATA_SUCCESS',
  GET_SUMMARY_DATA_ERROR = 'GET_SUMMARY_DATA_ERROR',

  MIGRATE_VM_START = 'MIGRATE_VM_START',
  MIGRATE_VM_SUCCESS = 'MIGRATE_VM_SUCCESS',
  MIGRATE_VM_ERROR = 'MIGRATE_VM_ERROR',
}

export type ConfigureArchitecturePayload =
  | string
  | ISourceDataPayload
  | ITargetDataPayload
  | Error
  | null
  | IRowsData[]
  | IGetSourceDataPayload
  | IMigrateVMPayload;

export type ConfigureArchitectureAction = IStoreAction<
  ConfigureArchitectureActionTypes,
  ConfigureArchitecturePayload
>;

export class ConfigureArchitectureActions {
  public static sendSourceDataStart(
    sourceDataPayload: ISourceDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static sendSourceDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_SUCCESS,
      data,
    };
  }
  public static sendSourceDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_SOURCE_DATA_ERROR,
      data: error,
    };
  }

  // To get source table data for source tab
  public static getSourceDataStart(
    sourceDataPayload: IGetSourceDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SOURCE_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static getSourceDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SOURCE_DATA_SUCCESS,
      data,
    };
  }
  public static getSourceDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SOURCE_DATA_ERROR,
      data: error,
    };
  }

  // To get update table data for source tab
  public static updateSourceDataStart(
    sourceDataPayload: IGetSourceDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static updateSourceDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_SUCCESS,
      data,
    };
  }
  public static updateSourceDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_SOURCE_DATA_ERROR,
      data: error,
    };
  }

  public static sendTargetDataStart(
    sourceDataPayload: ITargetDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_TARGET_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static sendTargetDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_TARGET_DATA_SUCCESS,
      data,
    };
  }
  public static sendTargetDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.SEND_TARGET_DATA_ERROR,
      data: error,
    };
  }

  // get target tab data
  public static getTargetDataStart(
    sourceDataPayload: IGetSourceDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_TARGET_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static getTargetDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_TARGET_DATA_SUCCESS,
      data,
    };
  }
  public static getTargetDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_TARGET_DATA_ERROR,
      data: error,
    };
  }

  // update target tab data
  public static updateTargetDataStart(
    sourceDataPayload: ITargetDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_TARGET_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static updateTargetDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_TARGET_DATA_SUCCESS,
      data,
    };
  }
  public static updateTargetDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.UPDATE_TARGET_DATA_ERROR,
      data: error,
    };
  }

  // get summary
  public static getSummaryDataStart(
    sourceDataPayload: IGetSourceDataPayload,
  ): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_START,
      data: sourceDataPayload,
    };
  }
  public static getSummaryDataSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_SUCCESS,
      data,
    };
  }
  public static getSummaryDataError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.GET_SUMMARY_DATA_ERROR,
      data: error,
    };
  }

  // migrate VM
  public static migrateVMStart(sourceDataPayload: IMigrateVMPayload): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.MIGRATE_VM_START,
      data: sourceDataPayload,
    };
  }
  public static migrateVMSuccess(data: IRowsData[]): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.MIGRATE_VM_SUCCESS,
      data,
    };
  }
  public static migrateVMError(error: Error): ConfigureArchitectureAction {
    return {
      type: ConfigureArchitectureActionTypes.MIGRATE_VM_ERROR,
      data: error,
    };
  }
}
